<template>
  <div>
    <qb-table>
      <template v-slot:thead>
        <qb-tr style="width">
          <qb-th class="f-14" style="width: 25%">
            {{ $t('client') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 10%">
            ID {{ $tc('entry', 1) | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 20%">
            {{ $t('provider') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 13%">
            {{ $tc('container', 2) | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 10%"> PO </qb-th>
          <qb-th class="f-14" style="width: 5%">
            {{ $t('aging') | capitalize }}
          </qb-th>
          <qb-th class="f-14 text-center" style="width: 12%">
            {{ $t('status') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 5%"></qb-th>
        </qb-tr>
      </template>
      <template v-slot:tbody>
        <qb-tr v-for="(el, idx) in data" :key="idx">
          <qb-td>{{ el.client_name | capitalize }}</qb-td>
          <qb-td>{{ el.entry_id | capitalize }}</qb-td>
          <qb-td>{{ el.provider_name | upperCase }}</qb-td>
          <qb-td>{{ el.container_string | upperCase }}</qb-td>
          <qb-td>{{ el.PO_number | upperCase }}</qb-td>
          <qb-td>{{ el.aging | capitalize }}</qb-td>
          <qb-td class="text-center" style=" justify-content: center !important; ">
            <vs-chip
              class="w-full"
              v-if="el.status_color != '#ffffff                  '"
              :color="
                el.status_color !== undefined
                  ? el.status_color.trim()
                  : '#626262'
              ">
              {{ el.status_name }}
            </vs-chip>
            <vs-chip
              v-else
              :color="'#626262' "
              class="w-full">
              {{ el.status_name }}
            </vs-chip>
          </qb-td>
          <qb-td>
            <action-icon
              icon="SidebarIcon"
              :tooltip="$t('details') | capitalize"
              @click="showDetails(el.id)"
          /></qb-td>
        </qb-tr>
        <qb-tr>
          <qb-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </qb-td>
        </qb-tr>
      </template>
    </qb-table>
  </div>
</template>

<script>
import QbTable from '@/views/qb-components/table/QbTable.vue'
import QbTr from '@/views/qb-components/table/QbTr.vue'
import QbTh from '@/views/qb-components/table/QbTh.vue'
import QbTd from '@/views/qb-components/table/QbTd.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
export default {
  name: 'entry-table',
  components: {
    ActionIcon,
    QbTable,
    QbTr,
    QbTh,
    QbTd,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    showDetails(id) {
      this.$emit('showDetails', id)
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
  },
}
</script>

<style>
.chip-status {
  max-width: 9rem;
  min-width: 2rem;
  color: white;
  text-align: center;
  border-radius: 0.3em;
}
</style>
